import { Avatar, Modal } from 'antd'
import Flex from 'components/Flex'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const SectionWrapper = styled.div`
  width: 100%;
  // border: 1px solid ${COLORS.PAGE_BORDER};
  // box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  // height: calc(100vh - 142px);
  // overflow: scroll;
  overflow-x: hidden;
  // background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`

export const TopHeader = styled('div')`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const TitleFlex = styled(Flex)`
  margin-top: 30px;
`
export const TopFlex = styled(Flex)`
  // min-width: 100%;
`
export const ApplyJobDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
`
export const JobSubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const SubmitDiv = styled.div`
  display: flex;
  margin-bottom: 1rem;
  justify-content: end;
  margin-right: 1rem;
`
export const RightSection = styled(Flex)`
  justify-content: flex-end;
  gap: 20px;
  padding-bottom: 10px;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
`
export const SetNewRoleHeader = styled(Flex)`
  font-size: 20px;
  font-weight: bold;
  padding-top: 10px;
  // padding-top: 40px;
  padding-left: 3px;
  position: relative;
  width: 100%;
  // font-size: 17px;
  // font-weight: ${FONT.FW_700};
  color: ${COLORS.GREY_P_100};
`
export const ClearText = styled(Flex)`
  font-size: 14px;
  color: #e35e50;
  cursor: pointer;
  margin-left: 340px; /* Align to the right */
  font-weight: 700;
`

export const StyledInfiniteScroll = styled(InfiniteScroll)(({ padding }) => ({
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  ' &::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    backgroundColor: '#cccccc',
    display: 'none',
  },
  '&:hover': {
    '::-webkit-scrollbar-thumb': {
      display: 'block',
    },
  },
  padding: padding || 'inherit',
}))

export const StyledAvatar = styled(Avatar)(({ isImage }) => ({
  border: isImage ? '2px solid #E6E7EA' : 'unset',
  boxShadow: isImage ? '0px 0px 4px 0px #00000040 inset' : 'unset',
  color: '#FFFFFF',
  '.ant-avatar-string': {
    top: isImage ? -2 : 'unset',
  },
}))

export const StyledModalDialog = styled(Modal)(({ removeSpacing }) => ({
  '.ant-modal-content': {
    boxShadow: '0px 6px 10px 0px #565E6A1A',
    paddingLeft: removeSpacing ? '20px' : '100px',
    paddingRight: removeSpacing ? '20px' : '100px',
    paddingTop: 20,
    paddingBottom: 20,
    borderRadius: '20px',
    margin: removeSpacing ? '5%' : 0,
  },
}))
